import {
  SUBSIDIARIES,
  JURISDICTION_AREAS,
  INVOICE_TYPES,
  TAX_RATES,
  ENTERPRISE_NATURES,
  COMMON_LEVELS,
  CUSTOMER_ATTRIBUTES,
  CUSTOMER_SCALES,
  SUPPLIER_CATEGORIES,
  REGISTERED_CURRENCIES,
  NATIONAL_ECONOMY_CATEGORIES,
  MAIN_SUPPLY_REGIONS,
  COMMON_BANKS,
  PROVINCES,
  OPERATING_STATUS,
} from './constants';

// 集团统一编码规则：CRRG-{类型代码}-{区域代码}-{年份}-{序号}
const typeCodeMap = { main: 'M', non_main: 'N' };
const regionCodes = ['BJ', 'SH', 'GZ', 'SZ', 'TJ', 'SZH', 'HZ', 'NJ', 'CD', 'WH', 'CQ', 'NB', 'DG', 'FS', 'WX', 'CS', 'ZZ', 'HF', 'QD', 'DL'];

const subsidiaryValues = SUBSIDIARIES.map(s => s.value);

const supplierNames = [
  '华再生环保科技有限公司', '格林美金属回收有限公司', '中环再生资源利用有限公司',
  '鑫源有色金属冶炼有限公司', '蓝鲸新能源科技有限公司', '绿洲环保材料有限公司',
  '瑞丰再生塑料科技有限公司', '博远电子废弃物处理有限公司', '金诚废旧金属回收有限公司',
  '天洁环保工程有限公司', '万邦再生资源回收有限公司', '中盛稀有金属提炼有限公司',
  '恒达废钢铁加工配送有限公司', '永清环保科技有限公司', '新力塑料再生利用有限公司',
  '宝丰资源循环科技有限公司', '融汇再生能源科技有限公司', '凯瑞废纸回收加工有限公司',
  '佳禾生物质能源有限公司', '顺达废金属回收有限公司', '创联环保科技集团有限公司',
  '宏图再生资源开发有限公司', '启明环保材料科技有限公司', '汇源废塑综合利用有限公司',
  '长江有色金属回收有限公司', '鼎盛资源再生科技有限公司', '绿源环保设备制造有限公司',
  '瑞祥再生纸业有限公司', '福临门再生资源有限公司', '中鼎废电池回收处理有限公司',
  '华鑫环保科技有限公司', '德润资源综合利用有限公司', '宏盛塑料再生有限公司',
  '天宏环保工程有限公司', '国盛稀有金属回收有限公司', '正达再生资源科技有限公司',
  '鑫隆废旧物资回收有限公司', '科源环保新材料有限公司', '合力废钢铁回收有限公司',
  '兴源再生能源科技有限公司', '明辉环保科技有限公司', '安泰再生塑料有限公司',
  '永丰资源循环利用有限公司', '金鹏废旧电子回收有限公司', '泰和环保材料有限公司',
  '鸿运再生金属有限公司', '大地环保科技集团有限公司', '益达资源再生有限公司',
  '中瑞有色金属综合利用有限公司', '信达废塑回收科技有限公司', '东方再生资源开发有限公司',
  '华泰环保工程有限公司', '恒基废旧物资回收有限公司', '旭日新能源材料有限公司',
  '长城资源循环科技有限公司',
];

const businessScopes = [
  '再生资源回收、加工、销售；废旧金属、废塑料、废纸的回收利用',
  '有色金属冶炼废渣综合利用技术研发、咨询及服务',
  '废弃电器电子产品回收处理；资源再生利用技术研发',
  '环保技术开发、咨询、服务；环保工程设计与施工',
  '再生塑料颗粒生产销售；塑料制品加工制造',
  '废旧电池回收处理；新能源材料研发生产',
  '废钢铁加工配送；金属废料和碎屑加工处理',
  '节能环保设备研发制造；环境治理服务',
  '再生资源回收利用；固体废物治理；危险废物经营',
  '废旧轮胎综合利用；橡胶制品生产销售',
  '稀贵金属提取冶炼；矿产综合利用技术研发',
  '建筑废弃物再生利用；新型建材生产销售',
  '废纸回收加工；纸浆及纸制品生产销售',
  '废弃油脂回收处理；生物柴油生产销售',
  '电子废弃物拆解处理；贵金属材料回收',
  '废旧纺织品回收利用；再生纤维生产销售',
  '污水处理及其再生利用；水污染治理',
  '大气污染治理；除尘脱硫脱硝设备制造',
  '土壤修复技术研发；生态恢复与生态保护服务',
  '新能源废旧设备回收处理；储能材料回收利用',
];

const mainProductsList = [
  '废铜、废铝、废锌等有色金属', '再生PE、PP、PVC塑料颗粒',
  '废旧钢铁、不锈钢废料', '再生纸浆、包装纸板',
  '废旧电池、正负极材料', '废旧轮胎、再生橡胶',
  '废电路板、贵金属提取物', '再生PET瓶片、涤纶短纤维',
  '环保设备、分选设备', '废电机、废变压器拆解回收',
  '再生铝合金锭、锌合金锭', '废玻璃、再生玻璃制品',
  '废旧纺织品、再生棉纱', '废矿物油、再生基础油',
  '建筑废料再生骨料', '废旧光伏组件回收处理',
  '废弃风机叶片回收处理', '废碳纤维复合材料回收',
  '再生ABS、PS塑料颗粒', '废锡、废铅等稀有金属',
];

const contactPeople = [
  '张伟', '李娜', '王强', '刘洋', '陈明', '杨磊', '赵丽', '黄海',
  '周建', '吴芳', '徐军', '孙鹏', '马超', '朱红', '胡兵', '郭涛',
  '何平', '林峰', '高燕', '罗辉', '梁欣', '宋琳', '唐杰', '韩冰',
  '曹阳', '许敏', '邓刚', '冯雪', '彭凯', '蒋宁', '蔡波', '贾婷',
  '丁勇', '魏彬', '薛亮', '叶兰', '阎锋', '余蕾', '潘磊', '杜鹃',
];

// 个人供应商姓名池（用于 entityType === 'individual'）
const individualNames = [
  '陈国强', '王秀梅', '李建国', '张桂兰', '刘志强', '杨春华', '赵金龙', '孙丽华',
  '周文斌', '吴红梅', '郑海涛', '冯玉珍', '钱伟民', '蒋淑芬', '韩立军', '沈秀英',
];

// 个人供应商主要经营品类
const individualProducts = [
  '废纸箱、旧报纸回收', '废铜废铝零散回收', '废旧家电上门回收',
  '废塑料瓶、编织袋回收', '废铁、废钢边角料回收', '废旧电瓶回收',
  '废玻璃、酒瓶回收', '生活废品综合回收',
];


const addresses = [
  '北京市大兴区工业开发区科创路18号',
  '上海市浦东新区临港重装备产业区海港大道555号',
  '广州市黄埔区开发大道388号',
  '深圳市坪山区坪山街道六和社区兰竹东路8号',
  '天津市滨海新区塘汉路88号',
  '苏州市工业园区胜浦街道澄浦路16号',
  '杭州市富阳区春江街道新建村',
  '南京市江宁区禄口街道神州路28号',
  '成都市青白江区工业集中发展区创新路66号',
  '武汉市蔡甸区常福工业示范园启动区',
  '重庆市巴南区经济园区花溪工业园',
  '宁波市镇海区澥浦镇湾塘路128号',
  '东莞市清溪镇青湖工业园富士路6号',
  '佛山市顺德区杏坛镇工业园科技大道22号',
  '无锡市惠山区前洲街道工业园区恒达路9号',
  '长沙市望城区经济开发区腾飞路55号',
  '郑州市新郑市龙湖镇泰山路168号',
  '合肥市肥东县循环经济工业园',
  '青岛市即墨区蓝村街道工业园永安路66号',
  '大连市金州区站前街道工业园区B区18号',
];

const tagsPool = [
  '战略合作', '优质供应商', '新准入', '重点监控', '年度评审通过',
  '环保认证', 'ISO9001', 'ISO14001', '高新技术企业', '绿色供应链',
  '长协供应商', '紧急采购', '单一来源', '技术创新', '降本增效',
  '备选供应商', '区域领先', '全国布局', '上市公司', '国有企业',
];

function generateUnifiedCode(index) {
  const prefixes = ['91110108MA01', '91310115MA12', '91440106MA23', '91440300MA34', '91120116MA45', '91320594MA56', '91330183MA67', '91320115MA78'];
  const prefix = prefixes[index % prefixes.length];
  const chars = '0123456789ABCDEFGHJKLMNPQRTUWXY';
  let suffix = '';
  for (let i = 0; i < 6; i++) {
    suffix += chars[(index * 7 + i * 13 + 3) % chars.length];
  }
  return prefix + suffix;
}

function generatePhone(index) {
  const prefixes = ['138', '139', '136', '158', '159', '188', '187', '186', '135', '137', '155', '156', '182', '183', '176', '177'];
  const prefix = prefixes[index % prefixes.length];
  const middle = String(1000 + ((index * 7919 + 1234) % 8999));
  const tail = String(1000 + ((index * 5431 + 5678) % 8999));
  return prefix + middle + tail;
}

const grades = ['A', 'A', 'A', 'B', 'B', 'B', 'B', 'B', 'C', 'C', 'C', 'D'];

export const suppliers = Array.from({ length: 55 }, (_, index) => {
  const year = index < 30 ? 2024 : 2025;
  const seq = index < 30 ? index + 1 : index - 29;
  const type = index % 3 === 0 ? 'non_main' : 'main';
  const grade = grades[index % grades.length];
  const status = index < 3 ? 'blacklisted' : index < 6 ? 'suspended' : 'active';
  // 约 1/5 为个人供应商（个人多为非主营的零散回收类）
  const entityType = index % 5 === 0 ? 'individual' : 'enterprise';
  const isIndividual = entityType === 'individual';
  // 编码：企业按 M/N，个人用 P 前缀
  const typeCode = isIndividual ? 'P' : typeCodeMap[type];
  const regionCode = regionCodes[index % regionCodes.length];
  const code = `CRRG-${typeCode}-${regionCode}-${year}-${String(seq).padStart(4, '0')}`;
  // 个人姓名 / 企业公司名
  const personName = individualNames[index % individualNames.length];
  const displayName = isIndividual ? personName : supplierNames[index];
  const capital = [50, 100, 200, 500, 800, 1000, 1500, 2000, 3000, 5000][index % 10];
  const establishedYear = 2000 + (index % 24);
  const establishedMonth = String((index % 12) + 1).padStart(2, '0');
  const establishedDay = String((index % 28) + 1).padStart(2, '0');
  const subsidiaryCount = (index % 3) + 1;
  const subsidiaryStart = index % subsidiaryValues.length;
  const selectedSubsidiaries = [];
  for (let i = 0; i < subsidiaryCount; i++) {
    selectedSubsidiaries.push(subsidiaryValues[(subsidiaryStart + i) % subsidiaryValues.length]);
  }
  const contractCount = (index % 20) + 1;
  const totalAmount = contractCount * (50 + (index % 200));
  const evalScore = 60 + (index % 35);
  const supplierTags = [tagsPool[index % tagsPool.length]];
  if (grade === 'A') supplierTags.push('优质供应商');
  if (index % 5 === 0) supplierTags.push('高新技术企业');
  if (index % 4 === 0) supplierTags.push('ISO9001');

  // P1-1.3: 同一供应商在不同子公司可有不同业务类型（对齐制度第29条）
  const subsidiaryBusinessTypes = selectedSubsidiaries.map((sub, i) => {
    const subLabel = SUBSIDIARIES.find(s => s.value === sub)?.label || sub;
    // 部分供应商在不同子公司有不同业务类型
    let bizType;
    if (i === 0) {
      bizType = type; // 主类型
    } else {
      // 约30%概率在不同子公司有不同业务类型
      bizType = (index + i) % 3 === 0 ? (type === 'main' ? 'non_main' : 'main') : type;
    }
    return {
      subsidiary: sub,
      subsidiaryName: subLabel,
      businessType: bizType,
      businessTypeLabel: bizType === 'main' ? '主营业务' : '非主营业务',
    };
  });

  return {
    id: `supplier_${String(index + 1).padStart(3, '0')}`,
    name: displayName,
    code,
    unifiedCode: isIndividual ? '' : generateUnifiedCode(index),
    type,
    entityType,
    grade,
    status,
    contactPerson: isIndividual ? personName : contactPeople[index % contactPeople.length],
    contactPhone: generatePhone(index),
    registeredCapital: isIndividual ? null : capital,
    establishedDate: `${establishedYear}-${establishedMonth}-${establishedDay}`,
    registeredAddress: isIndividual ? '' : addresses[index % addresses.length],
    businessScope: isIndividual ? individualProducts[index % individualProducts.length] : businessScopes[index % businessScopes.length],
    mainProducts: isIndividual ? individualProducts[index % individualProducts.length] : mainProductsList[index % mainProductsList.length],
    subsidiaries: [...new Set(selectedSubsidiaries)],
    subsidiaryBusinessTypes,
    cooperationStartDate: `${2021 + (index % 5)}-${String((index % 12) + 1).padStart(2, '0')}-01`,
    qualificationExpiry: (() => {
      const d = new Date(`${2021 + (index % 5)}-${String((index % 12) + 1).padStart(2, '0')}-01`);
      d.setFullYear(d.getFullYear() + 3);
      return d.toISOString().split('T')[0];
    })(),
    contractCount,
    totalAmount,
    lastEvaluationDate: `2025-${String((index % 12) + 1).padStart(2, '0')}-${String((index % 28) + 1).padStart(2, '0')}`,
    lastEvaluationScore: evalScore,
    tags: [...new Set(supplierTags)],

    // ---- 扩展字段（对齐供应商字段梳理文档） ----
    ...(entityType === 'enterprise'
      ? {
          // ①基本信息
          jurisdiction: JURISDICTION_AREAS[index % JURISDICTION_AREAS.length].value,
          country: '中国',
          province: PROVINCES[index % PROVINCES.length].value,
          city: PROVINCES[(index + 1) % PROVINCES.length].label,
          mainBusiness: ['再生资源回收利用', '环保设备制造', '有色金属冶炼', '废塑料加工', '新能源材料'][index % 5],
          invoiceType: INVOICE_TYPES[index % INVOICE_TYPES.length].value,
          taxRate: TAX_RATES[(index % 6) + 1].value,
          enterpriseNature: ENTERPRISE_NATURES[index % ENTERPRISE_NATURES.length].value,
          commonLevel: COMMON_LEVELS[index % COMMON_LEVELS.length].value,
          customerAttribute: CUSTOMER_ATTRIBUTES[index % CUSTOMER_ATTRIBUTES.length].value,
          customerScale: CUSTOMER_SCALES[index % CUSTOMER_SCALES.length].value,
          supplierEmail: `contact@${supplierNames[index].replace(/[^a-zA-Z一-龥]/g, '').slice(0, 4).toLowerCase()}.com`,
          nationalEconomyCategory: NATIONAL_ECONOMY_CATEGORIES[index % NATIONAL_ECONOMY_CATEGORIES.length].value,
          mainSupplyRegion: MAIN_SUPPLY_REGIONS[index % MAIN_SUPPLY_REGIONS.length].value,
          operatingStatus: OPERATING_STATUS[status === 'active' ? 0 : index % OPERATING_STATUS.length].value,
          // ②供应商信息
          supplierCategory: SUPPLIER_CATEGORIES[index % SUPPLIER_CATEGORIES.length].value,
          // ③注册信息
          businessRegistrationNo: `9111${String(10000000 + index * 13579).slice(0, 8)}`,
          registeredCurrency: REGISTERED_CURRENCIES[0].value,
          paidInCapital: Math.round(capital * (0.5 + (index % 5) * 0.1)),
          legalRepresentative: contactPeople[(index + 3) % contactPeople.length],
          bankName: COMMON_BANKS[index % COMMON_BANKS.length].value,
          bankDetailName: COMMON_BANKS[index % COMMON_BANKS.length].label + '支行',
          bankAccount: `6222${String(1000000000000000 + index * 7919).slice(0, 16)}`,
          bankProvince: PROVINCES[index % PROVINCES.length].value,
          // ④付款银行
          paymentBankAccountName: supplierNames[index],
          paymentBankName: COMMON_BANKS[(index + 2) % COMMON_BANKS.length].value,
          paymentBankDetailName: COMMON_BANKS[(index + 2) % COMMON_BANKS.length].label + '支行',
          paymentBankAccount: `6228${String(1000000000000000 + index * 3571).slice(0, 16)}`,
          paymentBankProvince: PROVINCES[(index + 1) % PROVINCES.length].value,
          // ⑤开票信息
          invoiceBankName: COMMON_BANKS[(index + 4) % COMMON_BANKS.length].value,
          invoiceBankDetailName: COMMON_BANKS[(index + 4) % COMMON_BANKS.length].label + '支行',
          invoiceBankAccount: `6226${String(1000000000000000 + index * 5431).slice(0, 16)}`,
          invoiceBankProvince: PROVINCES[(index + 2) % PROVINCES.length].value,
          invoiceAddress: addresses[(index + 3) % addresses.length],
          invoicePhone: generatePhone(index + 100),
          invoiceRequirement: ['增值税专用发票，备注栏注明合同编号', '按月开具，次月5日前', '随货开具'][index % 3],
          // ⑦调研记录
          surveyInspector: contactPeople[index % contactPeople.length],
          surveyCounterpart: contactPeople[(index + 5) % contactPeople.length],
          surveyDate: `${2024 + (index % 2)}-${String((index % 12) + 1).padStart(2, '0')}-${String((index % 28) + 1).padStart(2, '0')}`,
          surveyLocation: addresses[index % addresses.length],
          plannedMonthlySupply: [50, 100, 200, 500, 1000, 2000][index % 6],
          mainCoopVarieties: ['废铜、废铝', '废塑料PE/PP', '废钢铁', '废旧电池', '废纸'][index % 5],
          settlementMethod: ['月结30天', '月结60天', '货到付款', '预付款'][index % 4],
          logisticsMethod: ['自提', '供应商配送', '第三方物流', '铁路运输'][index % 4],
          selfLogistics: index % 2 === 0,
          mainServiceClients: ['华东区域工厂', '华南加工中心', '北方冶炼厂', '总部直供'][index % 4],
          plannedCooperation: ['月供货量预计100吨，按季度调整', '年度框架协议，分批交付', '项目制合作，约定期限6个月'][index % 3],
          surveyInspectorOpinion: ['供应商资质齐全，生产设备完善，建议准入', '现场考察合格，符合准入条件', '需补充环评材料后重新评估'][index % 3],
          surveyCompanyOpinion: ['同意准入，建议纳入合格供应商库', '同意准入，建议先试用3个月', '符合条件，按标准流程准入'][index % 3],
        }
      : {
          // 个人类型 ①基本信息
          personName,
          position: ['个体回收户', '废品收购个体户', '回收经营者', '个体经营者'][index % 4],
          idCard: `1101${String(80 + index).padStart(2, '0')}19${String(70 + (index % 20))}0${String((index % 9) + 1)}15${String(1000 + index * 37).slice(0, 4)}`,
          idCardValidFrom: `${2015 + (index % 8)}-01-15`,
          idCardValidTo: `${2035 + (index % 8)}-01-15`,
          homeAddress: `${PROVINCES[index % PROVINCES.length].label}${['市朝阳区', '市海淀区', '市区建设路', '市新华街道', '县城关镇'][index % 5]}${100 + index}号`,
          taxRate: TAX_RATES[(index % 3) + 1].value,
          emergencyContact: contactPeople[(index + 7) % contactPeople.length],
          emergencyContactPhone: generatePhone(index + 200),
          residence: PROVINCES[index % PROVINCES.length].label + '省',
          province: PROVINCES[index % PROVINCES.length].value,
          city: PROVINCES[(index + 1) % PROVINCES.length].label,
          supplierEmail: `person${index + 1}@example.com`,
          nationalEconomyCategory: NATIONAL_ECONOMY_CATEGORIES[7].value,
          mainSupplyRegion: MAIN_SUPPLY_REGIONS[(index % 7) + 1].value,
          operatingStatus: 'normal',
          // 个人类型 ②财务信息
          paymentBankAccountName: personName,
          paymentBankName: COMMON_BANKS[index % COMMON_BANKS.length].value,
          paymentBankDetailName: COMMON_BANKS[index % COMMON_BANKS.length].label + '支行',
          paymentBankAccount: `6217${String(1000000000000000 + index * 4219).slice(0, 16)}`,
          paymentBankProvince: PROVINCES[index % PROVINCES.length].value,
        }),
  };
});

// ============================================================
// 演示数据：构造"博远电子废弃物处理有限公司"跨 3 家子公司的故事线
// 同一供应商在不同子公司准入，对应不同业务类型，体现"一主体一编码"
// ============================================================
const demoSupplier = suppliers.find(s => s.id === 'supplier_008');
if (demoSupplier) {
  demoSupplier.subsidiaries = ['subsidiary_4', 'subsidiary_6', 'subsidiary_1'];
  demoSupplier.subsidiaryBusinessTypes = [
    {
      subsidiary: 'subsidiary_4',
      subsidiaryName: '有色金属投资公司',
      businessType: 'main',
      businessTypeLabel: '主营业务',
    },
    {
      subsidiary: 'subsidiary_6',
      subsidiaryName: '绿色纤维有限公司',
      businessType: 'non_main',
      businessTypeLabel: '非主营业务',
    },
    {
      subsidiary: 'subsidiary_1',
      subsidiaryName: '资环链金再生资源公司',
      businessType: 'main',
      businessTypeLabel: '主营业务',
    },
  ];
}
